import styled from 'styled-components'
import { Popover } from '@mui/material'

interface Props {
  open: boolean
  anchorEl: HTMLElement | null
  handleClose: () => void
  children: JSX.Element
}

export default function RowMenu({ open, anchorEl, handleClose, children }: Props): JSX.Element {
  return (
    <StyledRowMenu
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      disableRestoreFocus={false}
    >
      {children}
    </StyledRowMenu>
  )
}

const StyledRowMenu = styled(Popover)`
  & > .MuiPopover-paper {
    min-width: 150px;
    padding: 10px 0;
    background-color: ${(props) => props.theme.customPalette.light};

    & > div,
    & > a {
      color: ${(props) => props.theme.palette.primary.main};
      display: block;
      cursor: pointer;
      text-decoration: none;
      padding: 5px 10px;
      &:not(.disabled):not(.MuiAlert-root):hover {
        background-color: ${(props) => props.theme.palette.primary.main};
        color: ${(props) => props.theme.customPalette.light};
      }
      &.disabled {
        color: ${(props) => props.theme.customPalette.mediumGray};
        pointer-events: none;
      }
    }
    & > a:visited {
      color: ${(props) => props.theme.palette.primary.main};
    }
  }
`
